/** Resposta GET /relatorios/apuracoes/validar-nova (IMP-001). */

export function bloqueiaCriacaoFromValidacao(validacaoApi) {
  return validacaoApi?.bloqueiaCriacao === true;
}

export function mensagensPorTipo(validacaoApi, tipo) {
  const lista = validacaoApi?.mensagens;
  if (!Array.isArray(lista)) return [];
  return lista.filter((m) => m?.tipo === tipo && String(m?.texto ?? "").trim());
}

export function mensagensErroFromValidacao(validacaoApi) {
  return mensagensPorTipo(validacaoApi, "erro");
}

export function mensagensInfoFromValidacao(validacaoApi) {
  return mensagensPorTipo(validacaoApi, "info");
}
